import classNames from 'classnames';
import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import { fullName } from '../../../../../services';
import { GeneralTable } from '../../../../components';

export const TrainingPlanOverview = ({ business, trainingPlans, cpdCategorys, goals }) => {
  const columns = [
    {
      key: 'name',
      name: 'Name',
      className: 'no-rotation'
    }
  ].concat(
    cpdCategorys.map(
      ({ name, parentCpdCategoryId }) => ({
        key: name,
        name: <div className={classNames('narrow columnLabel')}>{he.decode(name)}</div>
      })
    )
  ).concat(
    goals.map(
      ({ name }) => ({
        key: name,
        name: <div className='narrow columnLabel bold'>{name}</div>
      })
    )
  )
  const rows = fp.map(
    ({ user, ...rest }) => {
      const pairs = [
        ['name', { value: fullName(user) }]
      ].concat(
        cpdCategorys.map(
          ({ id, name, parentCpdCategoryId }) => [name, {
            className: classNames({ child: !!parentCpdCategoryId }),
            value: fp.flow(
              fp.get('cpdCategorys'),
              fp.find(
                ({ cpdCategory }) => cpdCategory.id === id
              ),
              fp.getOr(0)('cpdPoints')
            )(rest)
          }]
        )
      ).concat(
        goals.map(
          ({ id, name }) => [name, {
            value: fp.flow(
              fp.get('goals'),
              fp.find(
                ({ goalId }) => goalId === id
              ),
              fp.getOr(0)('points')
            )(rest)
          }]
        )
      )
      const row = fp.fromPairs(pairs)
      return row
    }
  )(trainingPlans)
  return (
    <div>
      <GeneralTable className='table--slanted' rows={rows} columns={columns} />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/containers/pages/app/account-settings/partials/training-plan-overview.js